import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ContactClassTypesEnum } from "../../../../Enums";
import {
  GetLookupItemsByLookupTypeName,
  lookupItemsGetId,
} from "../../../../Services";
import {
  AutocompleteComponent,
  Inputs,
  SelectComponet,
  PhonesComponent,
} from "../../../../Components";

export const VendorsFiltersComponent = ({
  translationPath,
  parentTranslationPath,
  changeContactClass,
  vendorContactClasses,
  vendorContactClassesFilter,
  selectedValuesInFilters,
  setSelectedValuesInFilters,
  filterValues,
  setFilterValues,
  isAdvanceSearchCleared,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState({
    agreementStatus: false,
    vendorCategory: false,
    country: false,
    city: false,
    vendorClass : false 
  });

  const [allItems, setAllItems] = useState({
    agreementStatus: [],
    vendorCategory: [],
    country: [],
    city: [],
    vendorClass : []
  });

  const [helperText, setHelperText] = useState({
    mobile: "",
    name: "",
  });

  const searchTimer = useRef(null);

  const getIsContactClassChecked = (item) =>
    vendorContactClassesFilter &&
    vendorContactClassesFilter.findIndex(
      (element) => element === item.value
    ) !== -1;


  const getLookupItemsByName = async (lookUpName, key) => {
    setIsLoading((item) => ({ ...item, [key]: true }));
    const result = await GetLookupItemsByLookupTypeName({
      lookUpName,
      pageSize: 1000,
      pageIndex: 1,
    });
    if (!(result && result.status && result.status !== 200)) {
      setAllItems((item) => ({
        ...item,
        [key]: (result && result.result) || [],
      }));
    } else setAllItems((item) => ({ ...item, [key]: [] }));
    setIsLoading((loading) => ({ ...loading, [key]: false }));
  };

  const lookupItemsGetIdAPI = async (key, key2, lookupTypeId) => {
    setIsLoading((item) => ({ ...item, [key]: true }));
    const result = await lookupItemsGetId({
      lookupTypeId: lookupTypeId,
    });
    if (!(result && result.status && result.status !== 200)) {
      setAllItems((item) => ({ ...item, [key2]: result || [] }));
    } else setAllItems((item) => ({ ...item, [key2]: [] }));
    setIsLoading((item) => ({ ...item, [key]: false }));
  };

  useEffect(() => {
    if (isAdvanceSearchCleared) {
      setAllItems({
        agreementStatus: [],
        vendorCategory: [],
        country: [],
        city: [],
        vendorClass : []
      });
      setHelperText({
        agreementStatus: false,
        vendorCategory: false,
        country: false,
        city: false,
        vendorClass : false 
      });
    }
  }, [isAdvanceSearchCleared]);
  
  useEffect(() => {
    if(allItems && allItems.vendorClass  && allItems.vendorClass.length === 0 )
    getLookupItemsByName('VendorClass' ,  'vendorClass') ;

  }, [allItems]);

  return (
    <div className="d-flex-column px-2 w-100 p-relative">
      <div className="px-2 d-flex-inline d-flex-v-center-h-between  px-2">
        {/* <div className="filter-part1"></div> */}
        <div className="w-50 px-2 mt-2 mb-2">
          <Inputs
            idRef="nameRef"
            wrapperClasses="w-100"
            inputPlaceholder={"vendor-name"}
            value={filterValues.name}
            onInputChanged={(e) => {
              let { value } = e?.target;
              setFilterValues((item) => ({
                ...item,
                name: value,
              }));
            }}
            onKeyUp={(e) => {
              let { value } = e.target;
              if (searchTimer.current) clearTimeout(searchTimer.current);
              searchTimer.current = setTimeout(() => {
                setSelectedValuesInFilters((item) => ({
                  ...item,
                  "vendor_name.name": value,
                }));
              }, 700);
            }}
            onKeyDown={() => {
              if (searchTimer) clearTimeout(searchTimer.current);
            }}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
          />
        </div>
        <div className="w-50 px-2 mb-2">
          <PhonesComponent
            idRef={`mobileRef`}
            value={filterValues?.mobile || ""}
            helperText={
              (helperText?.mobile !== "" && t(helperText?.mobile)) || ""
            }
            error={helperText?.mobile !== ""}
            inputPlaceholder={"enter-mobile-number"}
            onInputChanged={(value) => {
              let newValue = value;
              newValue = newValue.replaceAll(" ", "");

              if (
                (newValue !== "" && newValue.length < 7) ||
                (newValue !== "" && newValue.length > 14)
              ) {
                setHelperText((item) => ({
                  ...item,
                  mobile: t("please-enter-vaild-mobile-number"),
                }));
                setFilterValues((item) => ({
                  ...item,
                  mobile: newValue,
                }));
              } else {
                setHelperText((item) => ({ ...item, mobile: "" }));
                setFilterValues((item) => ({
                  ...item,
                  mobile: newValue.replaceAll(" ", ""),
                }));
              }
            }}
            onKeyUp={(e) => {
              let { value } = e.target;
              if (searchTimer.current) clearTimeout(searchTimer.current);
              searchTimer.current = setTimeout(() => {
                if (helperText.mobile !== "") return;
                setSelectedValuesInFilters((item) => ({
                  ...item,
                  "landline_number.phone": value.replaceAll(" ", "").replaceAll("-", "").replaceAll("(", "").replaceAll(")", ""),
                }));
              }, 700);
            }}
            onKeyDown={() => {
              if (searchTimer) clearTimeout(searchTimer.current);
            }}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
          />
        </div>
      </div>
      <div className="px-2 d-flex-inline d-flex-v-center-h-between  px-2">
        <div className="w-50 px-2">
          <AutocompleteComponent
            key={`vendorCategory`}
            selectedValues={selectedValuesInFilters?.vendorCategory}
            idRef={`vendorCategoryRef`}
            inputPlaceholder="select-vendor-category"
            multiple={false}
            data={allItems && allItems.vendorCategory}
            wrapperClasses="w-50-unset mb-2"
            displayLabel={(option) => (option && option.lookupItemName) || ""}
            onChange={(e, newValue) => {
              setSelectedValuesInFilters((item) => ({
                ...item,
                vendorCategory: newValue,
              }));
            }}
            isLoading={isLoading.vendorCategory}
            withLoader
            withoutSearchButton
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            onOpen={() => {
              if (allItems?.vendorCategory?.length === 0)
                getLookupItemsByName("VendorCategory", "vendorCategory");
            }}
          />
        </div>
        <div className="w-50 filter-part1">
          <AutocompleteComponent
            key={`AgreementStatus`}
            selectedValues={selectedValuesInFilters.agreementStatus || null}
            idRef={`AgreementStatusRef`}
            inputPlaceholder="select-agreement-status"
            multiple={false}
            data={allItems.agreementStatus}
            wrapperClasses="w-50-unset mb-2"
            displayLabel={(option) => (option && option.lookupItemName) || ""}
            onChange={(e, newValue) => {
              setSelectedValuesInFilters((item) => ({
                ...item,
                agreementStatus: newValue || null,
              }));
            }}
            withoutSearchButton
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            onOpen={() => {
              if (allItems?.agreementStatus?.length === 0)
                getLookupItemsByName(
                  "VendorAgreementStatus",
                  "agreementStatus"
                );
            }}
          />
        </div>
        <div className="mr-1 ml-1"></div>
      </div>
      <div className="px-2 d-flex-inline d-flex-v-center-h-between">
        <div className="w-50 px-2">
          <AutocompleteComponent
            key={`country`}
            selectedValues={filterValues?.country}
            idRef={`vcountryRef`}
            inputPlaceholder="select-country"
            multiple={false}
            data={allItems && allItems.country}
            wrapperClasses="w-50-unset mb-2"
            displayLabel={(option) => (option && option.lookupItemName) || ""}
            onChange={(e, newValue) => {
              setSelectedValuesInFilters((item) => ({
                ...item,
                "country.lookupItemName": newValue,
              }));
              setFilterValues((item) => ({
                ...item,
                country: newValue,
              }));
            }}
            isLoading={isLoading.country}
            withLoader
            withoutSearchButton
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            onOpen={() => {
              if (allItems?.country?.length === 0)
                lookupItemsGetIdAPI("country", "country", 16);
            }}
          />
        </div>
        <div className="w-50">
          <AutocompleteComponent
            key={`city`}
            selectedValues={filterValues?.city}
            idRef={`cityRef`}
            inputPlaceholder="select-city"
            multiple={false}
            data={allItems && allItems.city}
            wrapperClasses="w-50-unset mb-2"
            displayLabel={(option) => (option && option.lookupItemName) || ""}
            onChange={(e, newValue) => {
              setSelectedValuesInFilters((item) => ({
                ...item,
                "city.lookupItemName": newValue,
              }));
              setFilterValues((item) => ({
                ...item,
                city: newValue,
              }));
            }}
            isLoading={isLoading.city}
            withLoader
            withoutSearchButton
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            onOpen={() => {
              if (allItems?.city?.length === 0)
                lookupItemsGetIdAPI("city", "city", 17);
            }}
          />
        </div>
        <div className="mr-1 ml-1"></div>
      </div>
      <div className="px-2 d-flex-inline d-flex-v-center-h-between">
        <div className="px-2 w-100">
          <SelectComponet
            getIsChecked={getIsContactClassChecked}
            singleIndeterminate={
              vendorContactClasses &&
              vendorContactClasses.length &&
              vendorContactClasses.length > 0 &&
              allItems?.vendorClass.length > 0 &&
              allItems.vendorClass.length > vendorContactClasses.length
            }
            renderValue={(value) =>
              (vendorContactClasses.length > 0 && (
                <span>
                  {value.map((option, mapIndex) => {
                    let toReturn = "";
                    const optionIndex = allItems?.vendorClass.findIndex(
                      (element) => element?.lookupItemName === option
                    );
                    if (optionIndex !== -1) {
                      toReturn +=
                        allItems.vendorClass &&
                        allItems.vendorClass[optionIndex]?.lookupItemName;
                      if (mapIndex < value.length - 1) toReturn += ", ";
                    }
                    return toReturn;
                  })}
                </span>
              )) || <span>{t(`${translationPath}select-vendor-class`)}</span>
            }
            singleChecked={
              vendorContactClasses &&
              vendorContactClasses.length > 0 &&
              vendorContactClasses.length - 1
            }
            data={
              allItems &&
              allItems?.vendorClass.map((i) => ({ value: i.lookupItemName }))
            }
            value={vendorContactClassesFilter}
            isWithCheckAll
            valueInput="value"
            multiple={true}
            keyLoopBy="value"
            textInput="value"
            onSelectChanged={changeContactClass}
            wrapperClasses="w-auto"
            themeClass="theme-default"
            idRef="changeContactClassRef"
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            translationPathForData={translationPath}
          />
        </div>
      </div>
      <div className="vendors-filters-1">
        <div className="mr-1 ml-1"></div>
      </div>
    </div>
  );
};
